(function () {
  'use strict';

  // ---- LélekHorgony buy-box engine (product-AGNOSTIC) ----
  // Reimplements the Claude-Design DCLogic for the buy box: 3 bundle tiers
  // (1/2/3 db), a per-fork frequency selector (a bundle may MIX 128/528/4096),
  // a recomputing value stack, total/savings, and the gift/free-shipping rows.
  // Builds /cart/add.js line items (one per fork, grouped by frequency variant)
  // and opens the native Shrine cart drawer BY HAND (never Shrine open()/
  // renderContents() — that trips the trapFocus blank-drawer crash on the
  // empty->first-add transition). The Meta pixel rides the standard /cart/add.js.
  // Per-product differences (variant ids, gift label, default product code) come
  // from the section's data-config JSON; the pricing/freq tables are universal.

  // ----- Universal config (identical across all 3 products, per the .dc.html) -----
  var PER = { 1: 9690, 2: 8880, 3: 8070 };   // Ft per unit by bundle qty
  var REG = 9690;
  var GIFT_VALUE = 4990;                       // gift e-book value (bundle >= 2)
  var SHIP_VALUE = 1490;                        // express shipping value (bundle >= 3)
  var FREQ_NAME = { '128': 'Földelő', '528': 'Szeretet', '4096': 'Tisztító' };
  var FREQS = [
    { code: '128', hz: '128 Hz' },
    { code: '528', hz: '528 Hz' },
    { code: '4096', hz: '4096 Hz' }
  ];

  function fmt(n) {
    return n.toLocaleString('hu-HU').replace(/\s/g, ' ').replace(/,/g, ' ') + ' Ft';
  }

  // ---- Shrine cart drawer integration (hand-open; verbatim from the proven Waterly engine) ----
  function getDrawer() { return document.querySelector('cart-drawer'); }

  function shrineSwapDrawerHTML(state) {
    var html = state.sections && state.sections['cart-drawer'];
    if (html) {
      var rendered = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
      var target = document.getElementById('CartDrawer');
      if (rendered && target) target.innerHTML = rendered.innerHTML;
    }
    var bubbleHtml = state.sections && state.sections['cart-icon-bubble'];
    if (bubbleHtml) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        var rb = new DOMParser().parseFromString(bubbleHtml, 'text/html').querySelector('.shopify-section');
        if (rb) bubble.innerHTML = rb.innerHTML;
      }
    }
  }

  function shrineAddToCartAndRefresh(addBody, trigger) {
    var drawer = getDrawer();
    var sections = (drawer && typeof drawer.getSectionsToRender === 'function')
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer', 'cart-icon-bubble'];
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

    return fetch(addUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: JSON.stringify(Object.assign({}, addBody, {
        sections: sections,
        sections_url: window.location.pathname
      }))
    }).then(function (res) {
      if (!res.ok) {
        return res.json().catch(function () {
          return { status: res.status, message: 'HTTP ' + res.status };
        }).then(function (body) {
          if (body && typeof body === 'object' && !body.status) body.status = res.status;
          return body;
        });
      }
      return res.json();
    }).then(function (state) {
      if (state.status) { console.error('cart/add error', state); return state; }
      // Hand-open: swap content, drop is-empty, toggle .active by hand (no focus trap).
      shrineSwapDrawerHTML(state);
      if (drawer) {
        drawer.classList.remove('is-empty');
        if (typeof drawer.setActiveElement === 'function') {
          drawer.setActiveElement(trigger || document.activeElement);
        }
        drawer.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');
        var ov = document.getElementById('CartDrawer-Overlay');
        if (ov) ov.addEventListener('click', function () { if (typeof drawer.close === 'function') drawer.close(); });
        var xb = drawer.querySelector('.drawer__close');
        if (xb) xb.addEventListener('click', function () { if (typeof drawer.close === 'function') drawer.close(); });
      }
      return state;
    });
  }

  // ---- Per-section init ----
  function init(root) {
    if (!root || root.dataset.lhInit) return;
    root.dataset.lhInit = '1';

    var cfg = {};
    try { cfg = JSON.parse(root.getAttribute('data-config') || '{}'); } catch (e) { cfg = {}; }
    var variants = cfg.variants || {};                 // { '128': id, '528': id, '4096': id }
    var ownCode = String(cfg.product_code || '128');
    var giftLabel = cfg.gift_label || 'Ajándék Térkép';
    var freqNames = cfg.freq_names || FREQ_NAME;
    var giftLines = cfg.gift_lines || {};              // { '1':..., '2':..., '3':... }
    var ctaText = cfg.cta_text || 'KOSÁRBA TESZEM';
    var forkLabel = cfg.fork_label || 'Hangvilla';
    var valuePrefix = cfg.value_prefix || 'Hangvilla —';
    var freeLabel = cfg.free_label || 'INGYEN';
    var shipLabel = cfg.ship_label || 'Expressz szállítás';
    // Készlet: ami nincs raktáron, az nem jelenik meg választhatóként (cfg.available a Liquidből).
    var avail = cfg.available || {};
    var soldoutLabel = cfg.soldout_label || '';
    function isAvail(code) { return avail[code] !== false; }
    var freqsAvail = FREQS.filter(function (f) { return isAvail(f.code); });
    var startCode = isAvail(ownCode) ? ownCode : (freqsAvail.length ? freqsAvail[0].code : ownCode);

    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var forksWrap = q('[data-lh-forks]');
    var valueWrap = q('[data-lh-values]');
    var grossEl = q('[data-lh-gross]');
    var giftLineEl = q('[data-lh-giftline]');
    var ctaButtons = function () { return Array.prototype.slice.call(document.querySelectorAll('[data-lh-add]')); };

    var state = { bundle: parseInt(cfg.default_bundle, 10) || 1, freqs: [startCode, startCode, startCode] };

    function freqLabel(code) { return freqNames[code] || FREQ_NAME[code] || ''; }

    function renderForks() {
      if (!forksWrap) return;
      forksWrap.innerHTML = '';
      for (var i = 0; i < state.bundle; i++) {
        (function (idx) {
          var row = document.createElement('div');
          row.className = 'lh-buybox-fork';
          var lbl = document.createElement('div');
          lbl.className = 'lh-buybox-forklabel';
          lbl.textContent = forkLabel + ' #' + (idx + 1);
          var seg = document.createElement('div');
          seg.className = 'lh-buybox-seg';
          freqsAvail.forEach(function (f) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'lh-buybox-segbtn' + (state.freqs[idx] === f.code ? ' is-active' : '');
            b.innerHTML = '<span class="lh-buybox-seghz">' + f.hz + '</span>'
              + '<span class="lh-buybox-segname">' + freqLabel(f.code) + '</span>';
            b.addEventListener('click', function () { state.freqs[idx] = f.code; render(); });
            seg.appendChild(b);
          });
          row.appendChild(lbl);
          row.appendChild(seg);
          forksWrap.appendChild(row);
        })(i);
      }
    }

    function addValueRow(label, value, isFree) {
      var rowEl = document.createElement('div');
      rowEl.className = 'lh-buybox-vrow';
      var l = document.createElement('span');
      l.className = 'lh-buybox-vlabel';
      l.textContent = label;
      var v = document.createElement('span');
      v.className = 'lh-buybox-vval' + (isFree ? ' is-free' : '');
      v.textContent = value;
      rowEl.appendChild(l);
      rowEl.appendChild(v);
      valueWrap.appendChild(rowEl);
    }

    function renderValues() {
      var bundle = state.bundle;
      var selected = state.freqs.slice(0, bundle);
      var order = ['128', '528', '4096'];
      var counts = {};
      selected.forEach(function (c) { counts[c] = (counts[c] || 0) + 1; });
      if (valueWrap) {
        valueWrap.innerHTML = '';
        order.filter(function (c) { return counts[c]; }).forEach(function (c) {
          addValueRow(counts[c] + '× ' + valuePrefix + ' ' + c + ' Hz ' + freqLabel(c), fmt(counts[c] * PER[bundle]), false);
        });
        var giftV = bundle >= 2 ? GIFT_VALUE : 0;
        var shipV = bundle >= 3 ? SHIP_VALUE : 0;
        if (giftV) addValueRow(giftLabel, freeLabel, true);
        if (shipV) addValueRow(shipLabel, freeLabel, true);
      }
      var giftValue = bundle >= 2 ? GIFT_VALUE : 0;
      var shipValue = bundle >= 3 ? SHIP_VALUE : 0;
      var gross = REG * bundle + giftValue + shipValue;
      var total = PER[bundle] * bundle;
      if (grossEl) grossEl.textContent = fmt(gross);
      qa('[data-lh-total]').forEach(function (el) { el.textContent = fmt(total); });
      // primary CTA carries the total; sticky CTA keeps its own short label
      ctaButtons().forEach(function (btn) {
        var totalSpan = btn.querySelector('[data-lh-total]');
        if (totalSpan) totalSpan.textContent = fmt(total);
      });
      if (giftLineEl) giftLineEl.textContent = giftLines[String(bundle)] || '';
    }

    function renderBundles() {
      qa('[data-lh-bundle]').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-lh-bundle') === String(state.bundle));
      });
    }

    function render() {
      renderBundles();
      renderForks();
      renderValues();
    }

    qa('[data-lh-bundle]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.bundle = parseInt(b.getAttribute('data-lh-bundle'), 10) || 1;
        render();
      });
    });

    function buildItems() {
      var bundle = state.bundle;
      var counts = {};
      state.freqs.slice(0, bundle).forEach(function (c) { counts[c] = (counts[c] || 0) + 1; });
      var items = [];
      ['128', '528', '4096'].forEach(function (c) {
        if (counts[c] && variants[c]) {
          items.push({ id: parseInt(variants[c], 10), quantity: counts[c] });
        }
      });
      return items;
    }

    function handleAdd(btn) {
      if (btn.dataset.lhBusy || !freqsAvail.length) return;
      var items = buildItems();
      if (!items.length) return;
      var original = btn.getAttribute('data-default-label') || btn.textContent;
      btn.dataset.lhBusy = '1';
      var addBody = items.length === 1 ? items[0] : { items: items };
      shrineAddToCartAndRefresh(addBody, btn).then(function (resp) {
        delete btn.dataset.lhBusy;
        if (resp && resp.status) return;
      }).catch(function (err) {
        console.error('cart add failed', err);
        delete btn.dataset.lhBusy;
      });
    }

    // Bind CTA + sticky (both carry data-lh-add). Re-point on every init.
    document.querySelectorAll('[data-lh-add]').forEach(function (btn) {
      if (btn._lhAddHandler) btn.removeEventListener('click', btn._lhAddHandler);
      var handler = function (e) { e.preventDefault(); handleAdd(btn); };
      btn._lhAddHandler = handler;
      btn.addEventListener('click', handler);
    });

    render();

    // Ha egyik frekvencia sincs készleten: a gomb(ok) letiltva, „Elfogyott” felirattal.
    if (!freqsAvail.length) {
      ctaButtons().forEach(function (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        if (soldoutLabel) btn.textContent = soldoutLabel;
      });
    }
  }

  // ---- Sticky add-to-cart bar: show after the primary CTA scrolls out of view ----
  function initSticky() {
    var bar = document.querySelector('[data-lh-sticky-bar]');
    var anchor = document.getElementById('lh-buybox-cta');
    if (!bar || !anchor || bar.dataset.lhStickyInit) return;
    bar.dataset.lhStickyInit = '1';
    function onScroll() {
      var r = anchor.getBoundingClientRect();
      var past = r.bottom < 0; // primary CTA scrolled above viewport
      bar.classList.toggle('is-visible', past);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function boot() {
    document.querySelectorAll('[data-lh-buybox]').forEach(init);
    initSticky();
  }

  if (document.readyState !== 'loading') { boot(); }
  else { document.addEventListener('DOMContentLoaded', boot); }

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-lh-buybox]');
    if (r) { r.removeAttribute('data-lh-init'); delete r.dataset.lhInit; init(r); }
    initSticky();
  });
})();
